import { MonicaObject } from '.';
import * as marietta from '../..';
import { SVGSprite } from '../flash/display';

export class PinPanorama extends MonicaObject {

  static panoramaViewer: Window = null;

  textGroupView:SVGElement;

  pinView: SVGElement;

  // 表示非表示
  _visible: boolean;

  set visible(booValue: boolean) {
    this._visible = booValue;
    this.viewObj.style.visibility = booValue ? 'visible' : 'hidden';
  }

  get visible() { return this._visible; }

  constructor(_itemInfo: marietta.webcad.collection.ItemInfoCollection) {
    super(_itemInfo);
    this.resiztToTarget();
  }

  /** パノラマ画像を別ビューで表示 */
  public panoramaView() {
    const url = new URL("./panorama/viewer.html", document.location.href);
    if (PinPanorama.panoramaViewer && !PinPanorama.panoramaViewer.closed) {
      PinPanorama.panoramaViewer.close();
    }
    PinPanorama.panoramaViewer = window.open(url.toString(), 'Panorama Viewer');
    PinPanorama.panoramaViewer.onload = () => {
      if (!this.itemInfo.link) return;

      PinPanorama.panoramaViewer.postMessage({ path: this.itemInfo.link[0].url }, url.origin);
    };
  }

  private resiztToTarget() {
    if (marietta.webcad.WebCADGlobal.itemManager.itemController !== undefined || marietta.webcad.WebCADGlobal.itemManager.itemController !== null) {
      if (marietta.webcad.WebCADGlobal.itemManager.itemController instanceof marietta.webcad.control.ItemControllerPinText) {
        marietta.webcad.WebCADGlobal.itemManager.itemController.resizeToTarget();
      }
    }
  }

  /**
   * リドロー
   */
  reCreateImage = (): void => {
    // 再作成
    this.textGroupView.remove();
    this.createImage();
    this.resiztToTarget();
  }

  /**
   * ビューの作成
   */
  createImage() {
    const textString = this.itemInfo.text;
    const fontSize = this.itemInfo.font_size;
    let textArray: string[] = [];
    let viewObj: Element;
    // テキスト項目に複数行があることを確認してください
    if (textString.indexOf('\n') !== -1) {
      textArray = textString.split('\n');
    } else {
      textArray[0] = textString;
    }
    if (this.spt === undefined) {
      viewObj = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      viewObj.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.guid}`);
    } else {
      viewObj = this.spt.element;
    }
    this.textGroupView = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    this.textGroupView.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.guid}_pinTextGroup`);

    // テキストサイズを取得
    const textSize = marietta.webcad.util.TextUtil.getTextSizeWh(textString, marietta.webcad.WebCADGlobal.freeTextFontFamily, fontSize);
    this.itemInfo.width = textSize.width;
    this.itemInfo.height = textSize.height;

    this.pinView = document.createElementNS('http://www.w3.org/2000/svg', 'image');
    this.pinView.setAttributeNS(null, 'href', `${marietta.webcad.WebCADGlobal.webcad2Dmanager.webcad_url}assets/cameraImage.png`);
    this.pinView.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.guid}_pin`);
    this.pinView.setAttribute('width', '30px');
    this.pinView.setAttribute('height', '30px');
    this.pinView.setAttribute('x', '-15px');
    this.pinView.setAttribute('y', '-15px');

    this.textGroupView.appendChild(this.pinView);
    viewObj.appendChild(this.textGroupView);

    if (this.spt === undefined) {
      this.spt = new SVGSprite(viewObj);
    }
    this.spt.x = this.itemInfo.x;
    this.spt.y = this.itemInfo.y;
    this.spt.update();

    //アプリの状態に応じて表示を変える
    if( marietta.webcad.WebCADGlobal.webcad2Dmanager.pinVisible ){
      this.show();
    }else{
      this.hide();
    }

  }

  /**
   * Translateのアップデート
   */
  updateTransforms() {
    this.spt.x = this.itemInfo.x;
    this.spt.y = this.itemInfo.y;
    if (Number.isNaN(this.spt.scaleX)) this.spt.scaleX = 1;
    if (Number.isNaN(this.spt.scaleY)) this.spt.scaleY = 1;
    this.spt.rotation = this.itemInfo.rotation;
    this.spt.update();
  }

  /**
   * テキストアイテム itemInfoCollection データの更新
   */
  updateTextAttributes() {
    this.itemInfo.text_color = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.text_color;
    this.itemInfo.font_size = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.font_size;
    this.itemInfo.is_bold = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.is_bold;
    this.itemInfo.is_italic = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.is_italic;
    this.itemInfo.is_underline = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.is_underline;
    this.itemInfo.is_strike_through = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.is_strike_through;
    this.itemInfo.text_alignment = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.text_alignment;
    this.itemInfo.rotation = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.rotation;
  }

  /**
   * 表示ON
   */
  show() {
    // 表示の再設定
    this.visible = true;
  }

  /**
   * 表示ON
  */
  hide() {
    this.visible = false;
  }
}
